<div class="bg-blue-50 p-4 lg:py-5 lg:px-7 text-xs border-top-1 border-gray-400">
  <h5 class="text-sm">About FitnessForce</h5>
  <p class="line-height-3 text-gray-600"> Amazon Web Services uses information from your Amazon.com account to
    identify you and allow access to Amazon Web Services. Your use of this site is governed by our Terms of Use
    and Privacy Policy linked below. Your use of Amazon Web Services products and services is governed by the AWS
    Customer Agreement linked below unless you have entered into a separate agreement with Amazon Web Services or
    an AWS Value Added Reseller to purchase these products and services. The AWS Customer Agreement was updated on
    March 31, 2017. For more information about these updates, see Recent Changes.</p>
    <app-auth-footer></app-auth-footer>
  </div>